import React from 'react';
import { List, Filter, Datagrid, TextField, NumberField, SelectArrayInput, ReferenceArrayInput, AutocompleteArrayInput } from 'react-admin';

const choicesSizes = [
	{ id: '300x250', name: '300x250' },
	{ id: '728x90', name: '729x90' },
	{ id: '300x600', name: '300x600' },
	{ id: '160x600', name: '160x600' },
	{ id: '120x600', name: '120x600' },
	{ id: '970x90', name: '970x90' },
	{ id: '970x250', name: '970x250' },
	{ id: '970x66', name: '970x66' },
	{ id: '300x1050', name: '300x1050' },
	{ id: '320x50', name: '320x50' },
	{ id: '300x50', name: '300x50' },
	{ id: '320x100', name: '320x100' }
]

var deviceTypeChoices = [
	{ id: 'Computer', name: 'Desktop' },
	{ id: 'Mobile', name: 'Mobile' },
	{ id: 'Tablet', name: 'Tablet' },
	{ id: 'Game Console', name: 'Game console' },
	{ id: 'Unknown', name: 'Unknown' }
];

const countryChoices = require('./components/countries.json')

const CustomSizeField = ({ record }) => {
    return <span><nobr>{record.adsize.w}x{record.adsize.h}</nobr></span>;
};

const PredictionsFilter = (props) => (
    <Filter {...props}>
		<ReferenceArrayInput alwaysOn source="site_id" label="Site" 
		  reference="sites"
		  basePath='sites'
  	      perPage={30}
    	  sort={{ field: 'name', order: 'ASC' }}
    	  filterToQuery={searchText => ({ search_name: searchText })}
    	  allowEmpty>
          <AutocompleteArrayInput label="Sites" optionText="adunit_path" optionValue="code" />
        </ReferenceArrayInput>
		<ReferenceArrayInput source="publisher_id" label="Publisher" 
		  reference="publishers"
		  basePath='publishers'
    	  perPage={30} 
      	  sort={{ field: 'name', order: 'ASC' }}
      	  filterToQuery={searchText => ({ search_name: searchText })}
      	  allowEmpty>
          <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" />
        </ReferenceArrayInput>
		<ReferenceArrayInput source="bidder_id" label="Bidders" 
		  reference="bidders"
		  basePath='bidders'
    	  perPage={30}
      	  sort={{ field: 'name', order: 'ASC' }}
      	  filterToQuery={searchText => ({ search_name: searchText })}
      	  >
          <AutocompleteArrayInput 
            optionText={record => (record)?`${record.name} (${record.code})`:""} 
            optionValue="code" />
        </ReferenceArrayInput>
        <SelectArrayInput alwaysOn label="Countries" 
  	   		choices={countryChoices} 
  	   		source="country" 
      	/>
      	<SelectArrayInput alwaysOn label="Devices" choices={deviceTypeChoices} source="device" />
      	<SelectArrayInput label="Ad Sizes" 
      		source="adsize" 
      		choices={choicesSizes}
        />
    </Filter>
);

export const PredictionsList = (props) => (
    <List {...props} filters={<PredictionsFilter />} perPage={50} bulkActionButtons={false}>
        <Datagrid>
            <TextField source="publisher_id" label="Publisher ID" />
            <TextField source="publisher_name" label="Publisher" />
            <TextField source="site_id" label="Site ID" />
            <TextField source="adunit_path" label="Site" />
            <TextField source="bidder_id" label="Bidder ID" />
            <TextField source="country" label="Country" />
            <TextField source="device" label="Device" />
            <CustomSizeField label="Ad Size"/>
            <NumberField source="price" options={{ maximumFractionDigits: 5 }}/>
            <NumberField source="second_price" options={{ maximumFractionDigits: 5 }}/>
        </Datagrid>
    </List>
);
